import { render, staticRenderFns } from "./OrderDelivery.vue?vue&type=template&id=352bc6e6&scoped=true"
import script from "./OrderDelivery.vue?vue&type=script&lang=js"
export * from "./OrderDelivery.vue?vue&type=script&lang=js"
import style0 from "./OrderDelivery.vue?vue&type=style&index=0&id=352bc6e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352bc6e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352bc6e6')) {
      api.createRecord('352bc6e6', component.options)
    } else {
      api.reload('352bc6e6', component.options)
    }
    module.hot.accept("./OrderDelivery.vue?vue&type=template&id=352bc6e6&scoped=true", function () {
      api.rerender('352bc6e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/driver/components/OrderDelivery.vue"
export default component.exports